import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';

import { AuthService } from '../_services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    private isRefreshing = false;
    private refreshTokenSubject = new BehaviorSubject<string | null>(null);

    constructor(private auth: AuthService, private toastr: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            const isRefreshUrl = request.url.includes('/admin/refresh');
            const isExpired = err.status === 401 && err.error?.status?.message === 'TOKEN_EXPIRED';

            if (isExpired && !isRefreshUrl) {
                return this.handleTokenExpiry(request, next);
            }

            if (err.status === 401) {
                if (!(request.body && request.body.grant_type == 'password')) {
                    this.auth.logout();
                }
            }

            const error = err.error?.status?.message;
            if (!error && err.status !== 500 && err.status !== 404 && err.status !== 403 && err.status !== 409 && err.status !== 400 && err.status !== 503) {
                this.toastr.error("Failed to Load Server, Please Try Again Later..!")
            }
            return throwError(() => err.error);
        }));
    }

    private handleTokenExpiry(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.auth.refresh().pipe(
                switchMap((res: any) => {
                    this.isRefreshing = false;
                    const newToken = res.data.access_token;
                    this.refreshTokenSubject.next(newToken);
                    return next.handle(this.attachToken(request, newToken));
                }),
                catchError(err => {
                    this.isRefreshing = false;
                    this.auth.logout();
                    return throwError(() => err);
                })
            );
        }

        // Queue concurrent requests while refresh is in progress
        return this.refreshTokenSubject.pipe(
            filter(token => token !== null),
            take(1),
            switchMap(token => next.handle(this.attachToken(request, token!)))
        );
    }

    private attachToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
        return request.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
        });
    }
}
